<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<tour-step-template>
    <ng-template let-step="step">
        <mat-card
            (click)="$event.stopPropagation()"
            [style.width]="step.stepDimensions?.width"
            [style.min-width]="step.stepDimensions?.minWidth"
            [style.max-width]="step.stepDimensions?.maxWidth">
            <mat-card-header>
                <div class="header-group">
                    <mat-card-title>
                        {{ step.title }}
                    </mat-card-title>
                </div>
            </mat-card-header>

            <mat-card-content class="mat-body" [innerHTML]="step.content">
            </mat-card-content>

            <mat-card-actions [class.no-progress]="!step.showProgress" [class.end-of-tour]="!tourService.hasNext(step)">
                @if (tourService.hasNext(step)) {
                    <button id="skip-tour-button" mat-flat-button class="skip" (click)="tourService.end()">
                        {{'tour.skipBtnTitle' | translate}}
                    </button>
                }
                @if (step.showProgress && tourService.hasNext(step)) {
                    <div class="progress">{{ tourService.steps.indexOf(step) + 1 }}/ {{ tourService.steps.length }}
                    </div>
                }
                @if (tourService.hasNext(step) && !step.nextOnAnchorClick) {
                    <button id="next-tour-button" class="next" (click)="tourService.next()" mat-flat-button>
                        {{ step.nextBtnTitle }}
                        <span class="mdi mdi-chevron-right"></span>
                    </button>
                }
                @if (!tourService.hasNext(step)) {
                    <button id="end-tour-button" class="end" mat-flat-button (click)="tourService.end()">
                        {{ step.endBtnTitle }}
                    </button>
                }
            </mat-card-actions>
        </mat-card>
    </ng-template>
</tour-step-template>